<!--
  !! COMPONENTE EM FASE BETA

  TODO: Refatorar para que o componente aceite um array de itens só de strings

  TODO: Refatorar para aceitar a prop `return-object`
-->
<template>
  <v-autocomplete
    ref="largeAutocomplete"
    class="large-data-autocomplete"
    style="border-radius: var(--component-input-md-radius) !important"
    multiple
    eager
    outlined
    v-bind="$props"
    :dense="isDense"
    :class="{small}"
    :search-input="searchInput"
    :items="computedItems"
    :value="currentValues"
    @update:search-input="onSearchInput"
  >
    <template #item="{item, attrs}">
      <v-list-item v-bind="attrs" @click="onChange(item[itemValue])">
        <v-list-item-action>
          <z-icon>
            {{
              attrs.inputValue
                ? '$check_box_rounded'
                : '$check_box_outline_blank_rounded'
            }}
          </z-icon>
        </v-list-item-action>

        <v-list-item-content>
          <v-list-item-title>
            {{ item[itemText] || item }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>

    <template #selection="{index, attrs}">
      <div v-if="index === 0" v-bind="attrs" class="truncate">
        {{ getAllSelectedValues }}
      </div>
    </template>

    <template v-if="filteredItems.length > 0" #prepend-item>
      <div v-ripple tabindex="0" class="zoox-select-all" @click="onToggleAll">
        <div class="action">
          <z-icon :color="hasSelectionInFilteredItems ? 'primary' : ''">
            {{
              hasSelectionInFilteredItems
                ? '$check_box_rounded'
                : '$check_box_outline_blank_rounded'
            }}
          </z-icon>
        </div>

        <div :style="{fontSize: isDense ? '.8125rem' : '1rem'}" class="content">
          {{
            hasSelectionInFilteredItems ? $t('uncheck_all') : $t('check_all')
          }}
        </div>
      </div>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change',
  },

  i18n: {
    messages: {
      pt: {
        no_data_available: 'Nenhum dado disponível',
        check_all: 'Selecionar todos',
        uncheck_all: 'Desmarcar todos',
      },
      en: {
        no_data_available: 'No data available',
        check_all: 'Select all',
        uncheck_all: 'Uncheck all',
      },
      es: {
        no_data_available: 'Datos no disponibles',
        check_all: 'Seleccionar todos',
        uncheck_all: 'Desmarcar todos',
      },
      fr: {
        no_data_available: 'Aucune donnée disponible',
        check_all: 'Tout sélectionner',
        uncheck_all: 'Tout désélectionner',
      },
      tr: {
        no_data_available: 'Veri yok',
        check_all: 'Hepsini seç',
        uncheck_all: 'Hepsini iptal et',
      },
    },
  },

  props: [
    'items',
    'value',
    'itemText',
    'itemValue',
    'appendIcon',
    'hint',
    'label',
    'rules',
    'hideDetails',
    'noDataText',
    'small',
    'mediun',
    'large',
    'color',
  ],

  data() {
    return {
      isMounted: false,
      currentScrolling: 50,
      searchInput: '',
    }
  },

  computed: {
    filteredItems() {
      return this.items.filter((i) => {
        if (this.searchInput) {
          const item = i[this.itemText] || i

          return item
            .toLocaleLowerCase()
            .includes(this.searchInput.toLocaleLowerCase())
        }

        return true
      })
    },

    computedItems() {
      const startIndex = Math.max(0, this.currentScrolling - 50)
      const endIndex = Math.min(
        this.currentScrolling + 50,
        this.filteredItems.length
      )

      return this.filteredItems.slice(startIndex, endIndex)
    },

    currentValues() {
      const values = []

      for (const i of this.computedItems) {
        if (this.value.some((v) => v === i[this.itemValue])) {
          values.push(i[this.itemValue])
        }
      }

      return values
    },

    hasSelectionInFilteredItems() {
      if (!this.isMounted) return

      return this.filteredItems.some((i) => {
        return this.value.includes(i[this.itemValue])
      })
    },

    valuesAreStrings() {
      return this.value.every((val) => typeof val === 'string')
    },

    getAllSelectedValues() {
      if (this.valuesAreStrings) return this.value.join(', ')

      return this.value?.map((item) => item[this.itemText]).join(', ')
    },

    isDense() {
      const isMobile = this.$vuetify.breakpoint.xs

      if (!this.small && !this.medium && !this.large) {
        return isMobile ? false : true
      }

      if (this.large) {
        return false
      }

      return this.small || this.medium
    },
  },

  mounted() {
    this.isMounted = true
    this.handleMenuScroll()
    /**
     * @see https://stackoverflow.com/a/45011980
     */
    this.$watch(
      () => {
        return this.$refs.largeAutocomplete.isMenuActive
      },
      (val) => {
        if (val && this.searchInput) {
          this.$refs.largeAutocomplete.internalSearch = this.searchInput
        }
      }
    )
  },

  methods: {
    onSearchInput(value) {
      this.searchInput = value
    },

    onChange(value) {
      const indexOfValue = this.value.indexOf(value)

      if (indexOfValue > -1) {
        this.$emit(
          'change',
          this.value.filter((item) => item !== value)
        )
        return
      }

      this.$emit('change', this.value.concat(value))
    },

    handleMenuScroll() {
      const content = document.querySelector('.v-autocomplete__content')

      content.addEventListener('scroll', (evt) => {
        requestAnimationFrame(() => {
          const element = evt.currentTarget || evt.target
          const isOnStart = element.scrollTop === 0
          const isOnEnd =
            element.scrollHeight - element.scrollTop === element.clientHeight

          if (isOnStart) {
            if (this.currentScrolling <= 50) return
            this.currentScrolling -= 100

            //scroll para o final dos itens atuais
            this.$nextTick(() => {
              element.scrollTop = (this.computedItems.length - 8) * 40
            })
          }

          if (isOnEnd) {
            if (this.currentScrolling >= this.filteredItems.length - 100) return
            this.currentScrolling += 100

            // scroll para o inicio dos itens atuais
            this.$nextTick(() => {
              element.scrollTop = 36
            })
          }
        })
      })
    },

    onToggleAll() {
      this.$nextTick(() => {
        if (this.hasSelectionInFilteredItems) {
          const result = this.value.filter(
            (item) =>
              !this.filteredItems.map((i) => i[this.itemValue]).includes(item)
          )
          this.searchInput = ''

          this.$emit('change', result)
        } else {
          const result = this.value.concat(
            this.filteredItems.map((i) => i[this.itemValue])
          )

          this.$emit('change', result)
          //this.searchInput = ''
        }

        this.$refs.largeAutocomplete.lazySearch = ''
        this.$refs.largeAutocomplete.isMenuActive = false
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.v-list {
  padding: 0 !important;
}

.truncate {
  width: 100%;
  height: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.zoox-select-all {
  position: sticky;
  top: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  flex: 1 1 100%;
  padding: 0 16px;
  cursor: pointer;
  min-height: 40px;
  height: 40px;
  background-color: var(--white);
  user-select: none;
  border-bottom: 1px solid #cecece;

  & > :first-child {
    margin-right: 32px;
    display: inline-flex;
    min-width: 24px;
    align-self: center;
  }

  & > :last-child {
    flex: 1 1;
    padding: 12px 0;
    display: flex;
    align-self: center;
    align-items: center;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>

<style lang="scss">
@use '@scss/global' as g;

.large-data-autocomplete {
  &.small {
    @include g.zoox-small-form-input;

    .v-select__selections {
      font-size: var(--zoox-font-size-body3);
    }

    &.chips {
      .v-select__selections {
        padding: 6px 0 0 2px !important;
      }
    }
  }
}
</style>
